import { Empty, Loading, Plate, Chip, useFetch } from "@/components/common";
import { SecureImg, openFile } from "@/components/Photos";
import { fDate, fNum } from "@/lib/api";

const fTime = (iso) => (iso ? new Date(iso).toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" }) : "");

export function ReadingsHistory({ params, showUser, showVehicle = true }) {
  const { data, loading } = useFetch("/readings/history", params);
  if (loading) return <Loading />;
  if (!data?.length) return <Empty text="Aucun relevé" />;
  return (
    <div className="overflow-x-auto">
      <table className="tbl w-full" data-testid="readings-history">
        <thead><tr><th>Date / heure</th><th>Type</th>{showUser && <th>Commercial</th>}{showVehicle && <th>Véhicule</th>}<th className="text-right">Compteur validé</th><th className="text-right">Détecté (OCR)</th><th>Origine</th><th>Photo</th></tr></thead>
        <tbody>{data.map((r) => (
          <tr key={r.id} data-testid={`reading-row-${r.id}`}>
            <td>{fDate(r.date)} <span className="text-slate-400">{fTime(r.captured_at)}</span></td>
            <td>{r.type_label}</td>
            {showUser && <td>{r.user_name}</td>}
            {showVehicle && <td><Plate>{r.plate}</Plate></td>}
            <td className="text-right tabular-nums font-bold">{fNum(r.mileage)}</td>
            <td className="text-right tabular-nums text-slate-500">{r.detected_mileage != null ? fNum(r.detected_mileage) : "—"}</td>
            <td><Chip cls={r.source === "photo" ? (r.corrected ? "bg-amber-50 text-amber-700 border-amber-200" : "bg-emerald-50 text-emerald-700 border-emerald-200") : "bg-slate-100 text-slate-600 border-slate-300"} testid={`reading-source-${r.id}`}>{r.source_label}</Chip>
              {r.manual_reason_label && <div className="text-[11px] text-slate-400">{r.manual_reason_label}</div>}</td>
            <td>{r.file_id ? <button onClick={() => openFile(r.file_id)} title={`Photo prise le ${fDate(r.date)} à ${fTime(r.captured_at)}`} data-testid={`reading-photo-${r.id}`}><SecureImg id={r.file_id} className="w-12 h-12 rounded border" /></button> : "—"}</td>
          </tr>
        ))}</tbody>
      </table>
    </div>
  );
}
